import {
  CreateTrialRequestMutation,
  TrialRequestCreateInput,
  TrialRequestUpdateInput,
  UpdateTrialRequestMutation,
  useCreateTrialRequestMutation,
  useGetAvailableSlotsQuery,
  useUpdateTrialRequestMutation,
} from "@/__generated__/graphql";

export function useGetAvailableSlots({
  startDate,
  scheduleSlug,
  endDate,
}: {
  startDate: Date;
  scheduleSlug: string;
  endDate: Date;
}) {
  const { data, loading, error, refetch } = useGetAvailableSlotsQuery({
    variables: {
      startDate: startDate.toISOString(),
      scheduleSlug: scheduleSlug,
      endDate: endDate.toISOString(),
    },
    skip: !startDate || !scheduleSlug || !endDate,
    onError: (error) => {
      console.error(error);
    },
  });

  return {
    data,
    loading,
    error,
    refetch,
  };
}

export function useCreateTrialRequest({
  onCompleted,
}: {
  onCompleted?(data: CreateTrialRequestMutation): void;
}) {
  const [mutate] = useCreateTrialRequestMutation({
    onCompleted,
    refetchQueries: ["GetAvailableSlots"],
  });

  const createTrialRequest = async (input: TrialRequestCreateInput) => {
    try {
      const { data, errors } = await mutate({
        variables: {
          data: input,
        },
        onError: (error) => {
          console.error(error);
        },
      });

      if (errors) {
        throw errors[0];
      }

      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return createTrialRequest;
}

export function useUpdateTrialRequest({
  onCompleted,
  onError,
}: {
  onCompleted?(data: UpdateTrialRequestMutation): void;
  onError?(error: Error): void;
}) {
  const [mutate] = useUpdateTrialRequestMutation({
    onCompleted,
    onError,
    refetchQueries: ["GetAvailableSlots"],
  });

  const updateTrialRequest = async (
    id: string,
    updates: TrialRequestUpdateInput,
  ) => {
    try {
      const { data, errors } = await mutate({
        variables: {
          id,
          updates,
        },
        onError: (error) => {
          console.error(error);
        },
      });

      if (errors) {
        throw errors[0];
      }

      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return updateTrialRequest;
}
